import api from '../services/api';

// Action types for consistent logging
export const ActivityTypes = {
  PAGE_VISIT: 'PAGE_VISIT',
  DATA_REFRESH: 'DATA_REFRESH',
  USER_ACTION: 'USER_ACTION',
  TRANSACTION: 'TRANSACTION',
  SETTINGS: 'SETTINGS',
  AUTH: 'AUTH',
  ERROR: 'ERROR',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  SEARCH: 'SEARCH',
  FILTER: 'FILTER',
  SORT: 'SORT',
  DOWNLOAD: 'DOWNLOAD',
  UPLOAD: 'UPLOAD',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
  CREATE: 'CREATE',
  VIEW: 'VIEW',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  VERIFY: 'VERIFY',
  UNVERIFY: 'UNVERIFY',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
  RESET: 'RESET',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  PASSWORD_CHANGE: 'PASSWORD_CHANGE',
  PROFILE_UPDATE: 'PROFILE_UPDATE',
  NOTIFICATION: 'NOTIFICATION',
  NOTIFICATION_VIEW: 'NOTIFICATION_VIEW',
  NOTIFICATION_SEND: 'NOTIFICATION_SEND',
  NOTIFICATION_DELETE: 'NOTIFICATION_DELETE',
  NOTIFICATION_MARK_VIEWED: 'NOTIFICATION_MARK_VIEWED',
  NOTIFICATION_MARK_ALL_VIEWED: 'NOTIFICATION_MARK_ALL_VIEWED',
  REPORT: 'REPORT',
  ANALYTICS: 'ANALYTICS',
  CONFIGURATION: 'CONFIGURATION',
  BACKUP: 'BACKUP',
  RESTORE: 'RESTORE',
  SYSTEM: 'SYSTEM',
  SECURITY: 'SECURITY',
  AUDIT: 'AUDIT',
  MAINTENANCE: 'MAINTENANCE',
  DEBUG: 'DEBUG',
  TEST: 'TEST',
  DEPLOY: 'DEPLOY',
  RELEASE: 'RELEASE',
  VERSION: 'VERSION',
  UPDATE: 'UPDATE',
  PATCH: 'PATCH',
  HOTFIX: 'HOTFIX',
  FEATURE: 'FEATURE',
  BUGFIX: 'BUGFIX',
  REFACTOR: 'REFACTOR',
  OPTIMIZATION: 'OPTIMIZATION',
  CLEANUP: 'CLEANUP',
  MIGRATION: 'MIGRATION',
  INTEGRATION: 'INTEGRATION',
  API: 'API',
  WEBHOOK: 'WEBHOOK',
  CALLBACK: 'CALLBACK',
  EVENT: 'EVENT',
  TRIGGER: 'TRIGGER',
  SCHEDULE: 'SCHEDULE',
  CRON: 'CRON',
  JOB: 'JOB',
  TASK: 'TASK',
  PROCESS: 'PROCESS',
  WORKFLOW: 'WORKFLOW',
  PIPELINE: 'PIPELINE',
  QUEUE: 'QUEUE',
  STREAM: 'STREAM',
  BATCH: 'BATCH',
  BULK: 'BULK',
  MASS: 'MASS',
  BATCH_UPDATE: 'BATCH_UPDATE',
  BATCH_DELETE: 'BATCH_DELETE',
  BATCH_CREATE: 'BATCH_CREATE',
  BATCH_IMPORT: 'BATCH_IMPORT',
  BATCH_EXPORT: 'BATCH_EXPORT',
  BATCH_VERIFY: 'BATCH_VERIFY',
  BATCH_APPROVE: 'BATCH_APPROVE',
  BATCH_REJECT: 'BATCH_REJECT',
  BATCH_ENABLE: 'BATCH_ENABLE',
  BATCH_DISABLE: 'BATCH_DISABLE',
  BATCH_RESET: 'BATCH_RESET',
  BATCH_DOWNLOAD: 'BATCH_DOWNLOAD',
  BATCH_UPLOAD: 'BATCH_UPLOAD',
  BATCH_PROCESS: 'BATCH_PROCESS',
  BATCH_SCHEDULE: 'BATCH_SCHEDULE',
  BATCH_TRIGGER: 'BATCH_TRIGGER',
  BATCH_EVENT: 'BATCH_EVENT',
  BATCH_WEBHOOK: 'BATCH_WEBHOOK',
  BATCH_API: 'BATCH_API',
  BATCH_INTEGRATION: 'BATCH_INTEGRATION',
  BATCH_MIGRATION: 'BATCH_MIGRATION',
  BATCH_CLEANUP: 'BATCH_CLEANUP',
  BATCH_OPTIMIZATION: 'BATCH_OPTIMIZATION',
  BATCH_REFACTOR: 'BATCH_REFACTOR',
  BATCH_BUGFIX: 'BATCH_BUGFIX',
  BATCH_FEATURE: 'BATCH_FEATURE',
  BATCH_RELEASE: 'BATCH_RELEASE',
  BATCH_DEPLOY: 'BATCH_DEPLOY',
  BATCH_TEST: 'BATCH_TEST',
  BATCH_DEBUG: 'BATCH_DEBUG',
  BATCH_MAINTENANCE: 'BATCH_MAINTENANCE',
  BATCH_AUDIT: 'BATCH_AUDIT',
  BATCH_SECURITY: 'BATCH_SECURITY',
  BATCH_SYSTEM: 'BATCH_SYSTEM',
  BATCH_NOTIFICATION: 'BATCH_NOTIFICATION',
  BATCH_REPORT: 'BATCH_REPORT',
  BATCH_ANALYTICS: 'BATCH_ANALYTICS',
  BATCH_CONFIGURATION: 'BATCH_CONFIGURATION',
  BATCH_BACKUP: 'BATCH_BACKUP',
  BATCH_RESTORE: 'BATCH_RESTORE',
  BATCH_VERSION: 'BATCH_VERSION',
  BATCH_UPDATE: 'BATCH_UPDATE',
  BATCH_PATCH: 'BATCH_PATCH',
  BATCH_HOTFIX: 'BATCH_HOTFIX',
  BATCH_FEATURE: 'BATCH_FEATURE',
  BATCH_BUGFIX: 'BATCH_BUGFIX',
  BATCH_REFACTOR: 'BATCH_REFACTOR',
  BATCH_OPTIMIZATION: 'BATCH_OPTIMIZATION',
  BATCH_CLEANUP: 'BATCH_CLEANUP',
  BATCH_MIGRATION: 'BATCH_MIGRATION',
  BATCH_INTEGRATION: 'BATCH_INTEGRATION',
  BATCH_API: 'BATCH_API',
  BATCH_WEBHOOK: 'BATCH_WEBHOOK',
  BATCH_CALLBACK: 'BATCH_CALLBACK',
  BATCH_EVENT: 'BATCH_EVENT',
  BATCH_TRIGGER: 'BATCH_TRIGGER',
  BATCH_SCHEDULE: 'BATCH_SCHEDULE',
  BATCH_CRON: 'BATCH_CRON',
  BATCH_JOB: 'BATCH_JOB',
  BATCH_TASK: 'BATCH_TASK',
  BATCH_PROCESS: 'BATCH_PROCESS',
  BATCH_WORKFLOW: 'BATCH_WORKFLOW',
  BATCH_PIPELINE: 'BATCH_PIPELINE',
  BATCH_QUEUE: 'BATCH_QUEUE',
  BATCH_STREAM: 'BATCH_STREAM',
  BATCH_BATCH: 'BATCH_BATCH',
  BATCH_BULK: 'BATCH_BULK',
  BATCH_MASS: 'BATCH_MASS'
};

// Log levels for consistent severity tracking
export const LogLevels = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  DEBUG: 'DEBUG',
  CRITICAL: 'CRITICAL'
};

// Utility function for logging activities
export const logActivity = async ({
  action,
  details,
  level = LogLevels.INFO,
  metadata = {},
  timestamp = new Date().toISOString(),
  adminId = localStorage.getItem('adminId'),
  adminName = localStorage.getItem('adminName')
}) => {
  try {
    const activity = {
      action,
      details,
      level,
      metadata,
      timestamp,
      adminId,
      adminName
    };

    await api.dashboard.logAdminActivity(activity);
    return true;
  } catch (error) {
    console.error('Error logging activity:', error);
    return false;
  }
};

// Utility function for logging errors
export const logError = async (error, context = {}) => {
  return logActivity({
    action: ActivityTypes.ERROR,
    details: error.message || 'An error occurred',
    level: LogLevels.ERROR,
    metadata: {
      error: error.toString(),
      stack: error.stack,
      ...context
    }
  });
};

// Utility function for logging page visits with additional context
export const logPageVisit = async (pageName, additionalContext = {}) => {
  return logActivity({
    action: ActivityTypes.PAGE_VISIT,
    details: `Visited ${pageName} page`,
    metadata: {
      path: window.location.pathname,
      query: window.location.search,
      hash: window.location.hash,
      ...additionalContext
    }
  });
};

// Utility function for logging user actions
export const logUserAction = async (action, details, metadata = {}) => {
  return logActivity({
    action,
    details,
    metadata: {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      ...metadata
    }
  });
};

// Utility function for logging data operations
export const logDataOperation = async (operation, details, metadata = {}) => {
  return logActivity({
    action: operation,
    details,
    metadata: {
      timestamp: new Date().toISOString(),
      ...metadata
    }
  });
};

export default {
  ActivityTypes,
  LogLevels,
  logActivity,
  logError,
  logPageVisit,
  logUserAction,
  logDataOperation
}; 